import ShoppingListDetails from './ShoppingListDetails';

export default ShoppingListDetails;
